<template>
  <div id="ticket-dashboard" ref="ticketDashboard">
    <div class="filter-box">
      <div class="filter-input">
        <v-autocomplete outline flat dense hide-details height="38" :items="channelList" v-model="filter.channel"
                        placeholder="Channel" item-text="text"
                        item-value="value" :append-icon='`${filter.channel ? "" : $vuetify.icons.dropdown}`' @change="onRefresh">
        </v-autocomplete>
      </div>
      <div class="filter-input">
        <DatePickerOutline
            flat
            v-model="filter.from"
            :max="filter.to"
            hide-details
            append-icon=""
            prepend-inner-icon=""
            @change="onRefresh"
        />
      </div>
      <div class="filter-input">
        <DatePickerOutline
            flat
            hide-details
            append-icon="mdi-calendar"
            v-model="filter.to"
            :min="filter.from"
            :max="today"
            prepend-inner-icon=""
            @change="onRefresh"
        />
      </div>
      <div class="d-flex align-center justify-center btn-refresh" @click="onRefresh">
        <icon-base icon-color="#6B6F80" icon-hover-color="#6B6F80" style="padding-right: 6px">
          <icon-refresh/>
        </icon-base>
        <span>Refesh</span>
      </div>
    </div>
    <div class="ticket-dashboard-content">
      <div class="ticket-dashboard-total">
        <span>{{ overviewNearRealTime.opening + overviewNearRealTime.resolved }}</span>
        <span>Total Tickets</span>
      </div>
      <div class="ticket-dashboard-other">
        <div class="ticket-dashboard-opening">
          <span>{{ overviewNearRealTime.opening }}</span>
          <span>Opening tickets</span>
        </div>
        <div class="ticket-dashboard-close">
          <span>{{ overviewNearRealTime.resolved }}</span>
          <span>Closed tickets</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {sync} from "vuex-pathify";
import $const from "@/utils/const";
import upperFirst from "lodash/upperFirst";
import IconRefresh from "components/icons/IconRefresh";
import IconBase from "components/icons/IconBase";
import DatePickerOutline from "components/custom/DatePickerOutline";
import {mapActions, mapState} from "vuex";

export default {
  name: "TicketDashboard",
  components: {IconRefresh, IconBase, DatePickerOutline},
  mounted() {
    this.isMounted = true
    this.refreshInterval()
  },
  data() {
    return {
      isMounted: false,
      today: moment().format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapState('ticket', ['overviewNearRealTime']),
    filter: sync('ticket/overviewFilter'),
    cssVars() {
      if (this.isMounted) {
        return {
          '--ticket-dashboard-font-size': `${this.$refs.ticketDashboard.clientWidth / 60}px`
        }
      }
      return {
        '--ticket-dashboard-font-size': '0px'
      }
    },
    channelList() {
      return $const.ALL_CHAT_CHANNELS.map(o => {
        return {text: upperFirst(this.$t(o)), value: o}
      })
    },
    channels() {
      if (this.filter.channel === 'all' || this.filter.channel === '') {
        return $const.ALL_CHAT_CHANNELS.join()
      }
      return this.filter.channel
    }
  },
  methods: {
    ...mapActions('ticket', ['getOverviewByTime']),
    onRefresh() {
      this.getOverviewByTime(this.channels)
    },
    refreshInterval() {
      this.onRefresh()
      setTimeout(()=> {
        this.refreshInterval()
      }, 300*1000)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 38px;
}

::v-deep.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid #D9D9D9 !important;
}

::v-deep.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
  margin-top: 0 !important;
}

::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: white !important;
}

::v-deep.v-text-field .v-input__append-inner {
  margin-top: 8px !important;
}

::v-deep input {
  font-size: 14px;
}
::v-deep i {
  font-size: 20px !important;
}
#ticket-dashboard {
  background-color: white;
  border-radius: 5px;
  margin: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .filter-box {
    background-color: white;
    height: 38px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    align-items: center;
    .filter-input {
      max-width: 140px;
    }
    .btn-refresh {
      padding-left: 10px;
      cursor: pointer;
      span {
        font-size: 12px;
        color: #6B6F80
      }
    }
  }
  .ticket-dashboard-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    padding: 0 25px;
    .ticket-dashboard-total {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }

    .ticket-dashboard-total span:first-of-type {
      color: #45C08C;
      font-size: 6.450em;
      font-weight: bold;
      line-height: 1.2;
    }

    .ticket-dashboard-total span:last-of-type {
      color: #141519;
      font-size: 1.935em;
      line-height: 1.2;
    }
    .ticket-dashboard-other {
      width: 100%;
      display: flex;
      gap: 30px;
      .ticket-dashboard-opening {
        display: flex;
        flex-direction: column;
      }
      .ticket-dashboard-opening span:first-of-type {
        color: #E9BF2E;
        font-size: 3.87em;
        font-weight: bold;
        line-height: 1.2;
      }

      .ticket-dashboard-opening span:last-of-type {
        color: #141519;
        font-size: 1.935em;
        line-height: 1.2;
      }
      .ticket-dashboard-close {
        display: flex;
        flex-direction: column;
      }
      .ticket-dashboard-close span:first-of-type {
        color: #ED6666;
        font-size: 3.87em;
        font-weight: bold;
        line-height: 1.2;
      }

      .ticket-dashboard-close span:last-of-type {
        color: #141519;
        font-size: 1.935em;
        line-height: 1.2;
      }
    }
  }
}

</style>